import { memo } from 'react';
export const statusNamesEnum = {
    approved: 'approved',
    accepted: 'accepted',
    pending: 'pending',
    delivered: 'delivered',
    rejected: 'rejected',
    inReview: 'inReview',
    expired: 'expired',
    pledged: 'pledged',
};
export const statusLabels = {
    [statusNamesEnum.approved]: 'Approved',
    [statusNamesEnum.accepted]: 'Accepted',
    [statusNamesEnum.pending]: 'Pending',
    [statusNamesEnum.delivered]: 'Delivered',
    [statusNamesEnum.rejected]: 'Rejected',
    [statusNamesEnum.inReview]: 'In Review',
    [statusNamesEnum.expired]: 'Expired',
    [statusNamesEnum.pledged]: 'Pledged',
};
export const statusColorsMap = {
    approved: '#00D33B',
    accepted: '#7A3AED',
    pending: '#00D33B',
    delivered: '#FF7F11',
    rejected: '#d90f0f',
    inReview: '#00D33B',
    expired: '#d90f0f',
    pledged: '#8dcda0',
};
export const ProjectCardLabel = memo(({ status, color }) => (<div className="rounded-[5px] flex place-content-center flex-initial" style={{ backgroundColor: color }}>

		<span className="font-roboto text-[10px] font-medium tracking-[0.02em] px-2 py-1 text-black uppercase">
			{status}
		</span>
	</div>));
